import { render, staticRenderFns } from "./cobrancas.vue?vue&type=template&id=0dee19aa&"
import script from "./cobrancas.vue?vue&type=script&lang=ts&"
export * from "./cobrancas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports